// PROD / STAGING config selection, mirrors the /portal convention.
import { firebaseConfigProd } from './config-prod';
import { firebaseConfigStaging } from './config-staging';

export function getFireBaseConfig() {
  if (import.meta.env.VITE_FIREBASE_CONFIG === 'FIREBASE_CONFIG_STAGING') {
    return firebaseConfigStaging;
  }

  return firebaseConfigProd;
}

export function isStagingDb() {
  return import.meta.env.VITE_FIREBASE_CONFIG === 'FIREBASE_CONFIG_STAGING';
}
